module.exports = __webpack_public_path__ + "img/1485837251.b90881db.jpg";